module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "content-wrapper ods-main-container"
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Registro de ODS Fundação BB'
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_vm._m(0), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'ODS',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ods-content"
  }, [_c('odsCadastro')], 1), _vm._v(" "), _c('vue-snotify')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("Objetivos de Desenvolvimento Sustentável (ODS) - Favoritos Fundação BB")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a193e6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/odsFundacao.vue
// module id = 1917
// module chunks = 1